// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/styles.scss
// module id = 2074
// module chunks = 0